import { REFERRER_DATA_CORRECT_LABEL, referrerProspectConsentLabel } from '@brimo/shared';
import { Checkbox, TextField, Textarea } from '../../../ds/components';
import type { FieldErrors } from '../public/form';
import type { ReferrerForm } from './form';
import publicStyles from '../public/SelfDisclosurePublicPage.module.css';
import styles from './ReferrerIntakePage.module.css';

export interface ReferrerStepProps {
  form: ReferrerForm;
  errors: FieldErrors;
  organizationName: string;
  onChange: (patch: Partial<ReferrerForm>) => void;
}

/** Step 5 „Tippgeber\" of `/t/:token`: the referrer's own name, e-mail, phone, a note and the two confirmations. */
export function ReferrerStep({ form, errors, organizationName, onChange }: ReferrerStepProps) {
  return (
    <>
      <div className={publicStyles.card}>
        <div className={publicStyles.formGrid}>
          <TextField
            label="Name"
            required
            value={form.name}
            error={errors['name']}
            autoComplete="name"
            maxLength={120}
            className={publicStyles.field}
            onChange={(event) => onChange({ name: event.target.value })}
          />
          <TextField
            label="E-Mail"
            type="email"
            required
            value={form.email}
            error={errors['email']}
            autoComplete="email"
            maxLength={200}
            className={publicStyles.field}
            onChange={(event) => onChange({ email: event.target.value })}
          />
          <TextField
            label="Telefon"
            type="tel"
            value={form.phone}
            error={errors['phone']}
            autoComplete="tel"
            maxLength={40}
            className={publicStyles.field}
            onChange={(event) => onChange({ phone: event.target.value })}
          />
          <Textarea
            label="Hinweis"
            value={form.note}
            error={errors['note']}
            rows={4}
            autoGrow
            maxLength={2000}
            className={publicStyles.fieldWide}
            onChange={(event) => onChange({ note: event.target.value })}
          />
        </div>
      </div>

      <div className={publicStyles.card}>
        <div className={publicStyles.consentsTitle}>Bestätigungen</div>
        <div className={publicStyles.consentList}>
          <div className={publicStyles.consentRow}>
            <Checkbox
              label={`${REFERRER_DATA_CORRECT_LABEL} *`}
              checked={form.dataCorrect}
              className={styles.consent}
              onChange={(event) => onChange({ dataCorrect: event.target.checked })}
            />
            {errors['dataCorrect'] ? (
              <span className={publicStyles.fieldError} role="alert">
                {errors['dataCorrect']}
              </span>
            ) : null}
          </div>
          <div className={publicStyles.consentRow}>
            <Checkbox
              label={`${referrerProspectConsentLabel(organizationName)} *`}
              checked={form.prospectConsented}
              className={styles.consent}
              onChange={(event) => onChange({ prospectConsented: event.target.checked })}
            />
            {errors['prospectConsented'] ? (
              <span className={publicStyles.fieldError} role="alert">
                {errors['prospectConsented']}
              </span>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
}
